import React from 'react';
import { useReveal, PageHero, PillLink } from '../Components/shared';

function NotFound() {
  const ref = useReveal();
  return (
    <main id="main" ref={ref}>
      <PageHero eyebrow="404" title={['This page took', 'a wrong turn.']} lead="The page you're looking for doesn't exist or has moved.">
        <div className="btn-row" data-reveal style={{ '--d': 4 }}>
          <PillLink to="/">Back to home</PillLink>
          <PillLink to="/contact" variant="ink">Contact us</PillLink>
        </div>
      </PageHero>
    </main>
  );
}

export default NotFound;
